module.exports = __webpack_public_path__ + "static/img/grid_s.29aa2d2a.svg";